import { PROCESS_STEPS } from "../data/content";
import { Reveal } from "./Reveal";

export const Process = () => {
  return (
    <section data-testid="process-section" className="py-16 sm:py-20 lg:py-28 bg-brand-gray">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal">
              How It Works
            </p>
          </Reveal>
          <Reveal delay={1}>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-charcoal leading-[1.05]">
              Simple Catering Process.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 relative">
          {/* Connecting line on desktop */}
          <div
            aria-hidden="true"
            className="hidden lg:block absolute top-9 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-brand-charcoal/15 to-transparent"
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-8">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.num} delay={Math.min(i + 1, 4)}>
                <div
                  data-testid={`process-step-${s.num}`}
                  className="relative h-full rounded-3xl bg-white border border-black/5 p-6 sm:p-7 transition-all hover:-translate-y-0.5 hover:shadow-[0_22px_40px_-22px_rgba(17,17,17,0.2)]"
                >
                  <div className="flex items-center justify-between">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-charcoal text-brand-gold font-display font-black text-[14px] tracking-wider">
                      {s.num}
                    </span>
                    <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/40">
                      Step
                    </span>
                  </div>
                  <h3 className="mt-5 font-display font-bold text-[18px] sm:text-[19px] text-brand-charcoal tracking-tight leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[13.5px] text-brand-charcoal/70 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
